import { IRecurly, IRootState } from '@/@types'

import { GetterTree } from 'vuex'

const getters: GetterTree<IRecurly, IRootState> = {
  getRecurlyPricing: state => {
    return state.recurlyPricing
  },
  getRecurlyToken: state => {
    return state.recurlyToken
  },
  getRecurlyTokenActionIdn: state => {
    return state.recurlyTokenActionId
  },
  getRecurlyTokenActionResult: state => {
    return state.recurlyTokenActionResult
  },
}

export default getters
